import React from "react";
import {Box, Typography} from "@mui/material";

import SessionTimerDisplay from "../../sessions/SessionTimerDisplay";

const styles = {
    container: {
        timer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "0.5rem",
            marginBottom: "0.5rem"
        }
    },
    typography: {
        statusInfo: {
            marginRight: "0.3rem"
        }
    }
};

export default function SlidingSessionTimer({hours, minutes, seconds, sessionStatusInfo, isSessionStarted, isSessionEnded}) {

    return (
        <Box sx={styles.container.timer}>
            <Typography variant="body2" sx={styles.typography.statusInfo}>
                {sessionStatusInfo}
            </Typography>
            {
              !isSessionEnded
              &&
              (
                <SessionTimerDisplay
                  hours={hours}
                  minutes={minutes}
                  seconds={seconds}
                  isSessionStarted={isSessionStarted}/>
              )
            }
        </Box>
    );
}
